module.exports = __webpack_public_path__ + "static/media/chevron-square-left.2cba4e13.svg";